// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1DhAM","productName":"Table_productName__3cG_F"};